import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components';
import colors from '../../../lib/Colors';
import fonts from '../../../lib/Fonts';

const StyledLink = styled.a`
  -webkit-font-smoothing: auto !important; /* TODO: Remove after we pull out old Hubspot code - Hubspot override */
  border-radius: 3px;
  font-family: ${fonts.family.workSans};
  transition: opacity 0.2s ease-in-out;
  cursor: pointer;
  text-decoration: none;
  ${({size}) => {
  switch (size) {
    case 'small':
      return {
        width: '50px',
        fontSize: '12px',
        padding: '6px'
      }
    case 'large':
      return {
        width: '300px',
        fontSize: '18px',
        padding: '12px'
      }
    case 'veryLarge':
      return {
        width: '380px',
        fontSize: '18px',
        padding: '12px'
      }
    case 'full':
      return {
        display: 'block',
        width: '100%',
        fontSize: '16px',
        padding: '0'
      }
    case 'medium':
    default:
      return {
        width: '100px',
        fontSize: '16px',
        padding: '6px'
      }
  }
}}
  ${({variation}) => {
  switch (variation) {
    case 'text':
      return {
        /* TODO: Remove important after we pull out old Hubspot code - Hubspot override */
        color: `${colors.blue} !important`
      }
    case 'secondary':
      return {
        borderColor: colors.blue,
        background: colors.white,
        color: colors.blue
      }
    case 'primary':
    default:
      return {
        background: colors.blue,
        color: colors.white,
      }
  }
}}
  &:hover {
    opacity: 0.9;
    text-decoration: underline;
  }
`;

const ExternalLink = props => {
  const {children, onClick, ...rest} = props;
  const handleClick = (...args) => {
    if (typeof onClick === 'function') {
      onClick(...args)
    }
  };
  return (
    <StyledLink onClick={handleClick} {...rest}>
      {children}
    </StyledLink>
  )
};

ExternalLink.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.element,
    PropTypes.string,
  ]),
  href: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'veryLarge', 'full']),
  variation: PropTypes.string
};

ExternalLink.defaultProps = {
  href: '/',
  size: 'full',
  variation: 'text'
};

export default ExternalLink
